import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Principal } from '../shared';
import { VIEW_LOTS_PERMISSIONS, VIEW_TRANSACTIONS_PERMISSIONS } from '../shared/auth/permissions';

@Injectable()
export class TabRouteGuard implements CanActivate {

    constructor(private router: Router,
                private principal: Principal) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        return Promise.resolve(this.principal.identity().then((account) => {
            if (account && account.authorities && account.authorities.length) {
                if (account.authorities.some((auth) => VIEW_LOTS_PERMISSIONS.indexOf(auth) !== -1)) {
                    return true;
                } else if (account.authorities.some((auth) => VIEW_TRANSACTIONS_PERMISSIONS.indexOf(auth) !== -1)) {
                    // FIXME queryParamsHandling="merge" not working? https://stackoverflow.com/questions/39898656/angular2-router-keep-query-string/41696468#41696468
                    this.router.navigate(['transaction'], { queryParams: route.queryParams });
                    return false;
                }
            }

            this.router.navigate(['access-denied']);
            return false;
        }));
    }
}
